<template>
  <v-container>
    <v-col class="add_item-wrapper">
      <v-row justify="center">
        <v-col cols="10" xs="10" sm="8" md="8" lg="8" class="vertical-no-padding-col">
          <TitleLabel :title="title" />
        </v-col>
      </v-row>
      <v-row justify="center">
        <P class="thank-text">送信ありがとうございました。</P>
      </v-row>
      <v-row justify="center">
        <v-col cols="5" xs="5" sm="5" md="2" lg="2">
          <NormalSimpleButton button-title="もどる" @clickAction="backToCheck" />
        </v-col>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
import TitleLabel from '../Atoms/TitleLabel'
import NormalSimpleButton from '../Atoms/NormalSimpleButton'

export default {
  name: "AddItemResult",
  data: () => ({
    title: "追加したいエコを記入しよう！",
  }),
  created() {
    this.initIcon()
  },
  methods: {
    backToCheck() {
      this.$router.push('check')
    },
    initIcon() {
      this.$emit('initIcon')
    }
  },
  components:{
    TitleLabel,
    NormalSimpleButton
  }
};
</script>

<style scoped>
.other-team {
  min-height: 50vh;
}
.add_item-wrapper {
  padding: 10% 0 10% 0;
}
.thank-text {
  font-size: 1.8em;
  color: #fff;
}
@media screen and (max-width: 350px) {
  .thank-text {
    font-size: 1.2em;
  }
}
@media screen and (min-width: 351px) and (max-width: 768px) {
  .thank-text {
    font-size: 1.5em;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .thank-text {
    font-size: 1.8em;
  }
}
@media screen and (min-width: 1024px) {
}
</style>
